export interface MediaSaveLifecycle {
  onDrawingEvent?: (phase: 'drawing_started' | 'drawing_cleared' | 'drawing_empty') => void;
  onSaveStart?: () => Promise<void>;
  onSaveCancel?: () => void;
  onSaveError?: (error: unknown) => void;
}

/** Persiste a tentativa antes da conversao do desenho, sem tornar diagnostico um bloqueio. */
export const runMediaSave = async (save: () => void, callbacks: MediaSaveLifecycle): Promise<void> => {
  try { if (callbacks.onSaveStart) await callbacks.onSaveStart(); } catch { /* Falha aberta. */ }
  try { save(); } catch (error) {
    try { callbacks.onSaveError?.(error); } catch { /* Preserva o erro original. */ }
    throw error;
  }
};
